// 未保存のままタブを閉じようとしたら確認する。
// beforeunload は特にモバイルで発火しないことがあるので、保存の代わりにはしない。
import { onMounted, onBeforeUnmount } from 'vue'
import { useDocumentStore } from '@/stores/documentStore'
import { t } from '@/i18n'

export function useUnsavedGuard() {
  const docStore = useDocumentStore()
  function handler(e: BeforeUnloadEvent) {
    if (!docStore.isDirty) return
    e.preventDefault()
    e.returnValue = t('unsaved.beforeUnload')
  }
  onMounted(() => window.addEventListener('beforeunload', handler))
  onBeforeUnmount(() => window.removeEventListener('beforeunload', handler))
}
